/** Matches `FRAGMENT:{uuid}` social-export source keys. */
const FRAGMENT_KEY_RE =
  /^FRAGMENT:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/** Extracts the fragment UUID from a Pub/Sub `key` (`FRAGMENT:{uuid}`). */
function parseFragmentIdFromKey(key: unknown): string | null {
  if (typeof key !== 'string') {
    return null;
  }

  const match = key.match(FRAGMENT_KEY_RE);
  return match?.[1] ?? null;
}

/**
 * Builds the fragment publish tab path from a Pub/Sub `key` (`FRAGMENT:{uuid}`).
 */
export function getFragmentPublishPathFromKey(key: unknown): string | null {
  const fragmentId = parseFragmentIdFromKey(key);
  if (!fragmentId) {
    return null;
  }

  return `/fragments/${fragmentId}/publish`;
}
